module.exports = __webpack_public_path__ + "img/20191214143408283.8310b27d.jpg";